import React, { useState } from 'react';
import './LoginShop.css';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { loginfunction, sendotpfunction } from '../../services/Apis';
import { useGoogleLogin } from '@react-oauth/google';
import { BACKEND_URL } from '../../services/Helper';

const notifyB = (msg) => toast.success(msg);
const notifyA = (msg) => toast.error(msg);

const LoginShop = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleGetOtp = async (e) => {
    e.preventDefault();
    if (!email) {
      notifyA("Please enter your email");
      return;
    } else if (!email.includes("@")) {
      notifyA("Please enter a valid email");
      return;
    }

    try {
      setLoading(true);
      const data = { email };
      const response = await sendotpfunction(data);
      if (response.status === 200) {
        setOtpSent(true);
        localStorage.setItem('shopotpreq', 'true');
        notifyB("OTP Sent to Your Email Successfully");
      } else {
        notifyA(response.error || "Failed to send OTP");
      }
    } catch (error) {
      console.error(error);
      notifyA("Something went wrong while sending OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!otp) {
      notifyA("Please enter the OTP");
      return;
    } else if (otp.length !== 6) {
      notifyA("OTP should be 6 digits");
      return;
    }

    try {
      setLoading(true);
      const data = { email, otp };
      const response = await loginfunction(data);
      if (response.status === 200) {
        localStorage.setItem("shoplogintoken", response.data.token);
        localStorage.setItem("isAdmin", response.data.isAdmin ? 'true' : 'false');
        localStorage.setItem("isSuperAdmin", response.data.isSuperAdmin ? 'true' : 'false');
        localStorage.removeItem('shopotpreq');
        if (response.data.isAdmin) {
          navigate("/admin");
        } else {
          navigate("/shopowner/shopdashboard");
        }
        notifyB("Login Successful");
      } else {
        notifyA(response.error || "Login failed");
      }
    } catch (error) {
      console.error(error);
      notifyA("Something went wrong during login");
    } finally {
      setLoading(false);
    }
  };

  const responseGoogle = async (authResult) => {
    try {
      if (authResult && authResult.code) {
        // console.log("Google auth code:", authResult.code);

        const res = await fetch(`${BACKEND_URL}/nearbe/googlelogin`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ code: authResult.code, redirectUri: 'postmessage' })
        });

        const data = await res.json();
        // console.log("Backend response:", data);

        if (res.ok) {
          localStorage.setItem("shoplogintoken", data.token);
          localStorage.setItem("isAdmin", data.isAdmin ? 'true' : 'false');
          localStorage.setItem("isSuperAdmin", data.isSuperAdmin ? 'true' : 'false');
          notifyB("Logged in successfully with Google!");
          if (data.isAdmin) {
            navigate("/admin");
          } else {
            navigate("/shopowner/shopdashboard");
          }
        } else if (res.status === 400 && data.error && data.error.toLowerCase().includes("not registered")) {
          notifyA("Shop not registered. Redirecting to registration...");
          setTimeout(() => navigate("/shopregister"), 1500);
        } else {
          notifyA(data.error || "Google login failed");
        }
      } else {
        notifyA("Google login failed: No code received");
      }
    } catch (error) {
      console.error("Error while logging in with Google:", error);
      notifyA("Something went wrong with Google login");
    }
  };
  const googleLogin = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: responseGoogle,
    flow: 'auth-code'
  })

  const handleRegisterShop = () => {
    navigate("/shopregister");
  };

  return (
    <div className="loginshop-container">
      <form
        className="loginshop-form"
        onSubmit={otpSent ? handleLogin : handleGetOtp}
      >
        <h2>Shopkeeper Login</h2>

        <input
          type="email"
          placeholder="Enter your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        {otpSent && (
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />
        )}

        <button type="submit" className="loginshop-btn" disabled={loading}>
          {loading ? (
            <span className="spinner">
              <div className="spinner-circle"></div>
              {otpSent ? " Logging in..." : " Sending OTP..."}
            </span>
          ) : (
            otpSent ? "Login" : "Get OTP"
          )}
        </button>

        <p className="register-text">
          If Shop not registered?{" "}
          <button
            type="button"
            className="register-btn"
            onClick={handleRegisterShop}
          >
            Register Shop
          </button>
        </p>
        <div className="google-divider"><span>or</span></div>
        <button type="button" className="google-btn" onClick={googleLogin}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google"
            style={{ width: 20, height: 20 }}
          />
          Continue with Google
        </button>
      </form>
    </div>
  );
};

export default LoginShop;
